import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import dataTableData from "./data/dataTableData";
import { useEffect, useState } from "react";
import { RequestService } from "services/RequestService";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import AddIcon from "@mui/icons-material/Add";


function CompaniesDataTables() {
  const navigate = useNavigate();

  const [dataTableData2, setDataTableData] = useState(dataTableData);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [companyIdToDelete, setCompanyIdToDelete] = useState(null);

  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);

  const handleOpenDialog = (id) => {
    setCompanyIdToDelete(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCompanyIdToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (companyIdToDelete) {
      try {
        const result = await RequestService.delete(`company/${companyIdToDelete}`);
        if (result.status === 200) {
          toggleSnackbar();
          fetchCompanies(); // Refresh data after successful deletion
        } else {
          toggleSnackbar2();
        }
      } catch (error) {
        console.error("Error deleting company:", error);
        toggleSnackbar2();
      }
      handleCloseDialog();
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await RequestService.get("Companies");
      if (response.data.error === false) {
        const companyData = response.data.data.map((r, index) => {
          r.actions = (
            <MDBox display="flex">
              <MDButton
                href={`/projects/company/edit?id=${r.id}`}
                sx={{ marginRight: 2 }}
                color="info"
                variant="outlined"
              >
                تعديل
              </MDButton>
              {/* <MDButton color="error" variant="outlined" onClick={() => handleOpenDialog(r.id)}>
                حذف
              </MDButton> */}
            </MDBox>
          );
          r["#"] = index + 1;
          return r;
        });

        setDataTableData((prevState) => ({
          ...prevState,
          rows: companyData,
        }));
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  return (
    <DashboardLayout>
      <MDSnackbar
        color="success"
        icon="notifications"
        title="تم اتمام العملية"
        content="تم اتمام العملية بنجاح"
        dateTime="0 seconds ago"
        open={show}
        close={toggleSnackbar}
      />

      <MDSnackbar
        color="error"
        icon="notifications"
        title="اضافة شركة"
        content="حدث خطأ ما"
        dateTime="0 seconds ago"
        open={error}
        close={toggleSnackbar2}
      />
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                sx={{
                  backgroundColor: "grey.100",
                  borderBottom: "1px solid",
                  borderColor: "grey.300",
                }}
              >
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium">
                    قائمة الشركات
                  </MDTypography>
                  <MDTypography variant="button" color="text">
                    إدارة الشركات
                  </MDTypography>
                </MDBox>
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={() => {
                    navigate("/pages/projects/company/add");
                  }}
                  startIcon={<AddIcon />}
                >
                  إضافة شركة
                </MDButton>
              </MDBox>
              <MDBox pt={3}>
                <DataTable table={dataTableData2} canSearch />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="confirm-delete-dialog-title"
      >
        <DialogTitle id="confirm-delete-dialog-title">تأكيد الحذف</DialogTitle>
        <DialogContent>
          <DialogContentText>سيتم حذف بيانات هذا الحقل بشكل نهائي. هل أنت متأكد؟</DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleConfirmDelete} color="error">
            نعم
          </MDButton>
          <MDButton onClick={handleCloseDialog} color="secondary">
            لا
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default CompaniesDataTables;
